import { render, staticRenderFns } from "./LicitacaoVisualizacaoDadosGerais.vue?vue&type=template&id=398b0351&scoped=true&"
import script from "./LicitacaoVisualizacaoDadosGerais.vue?vue&type=script&lang=js&"
export * from "./LicitacaoVisualizacaoDadosGerais.vue?vue&type=script&lang=js&"
import style0 from "./LicitacaoVisualizacaoDadosGerais.vue?vue&type=style&index=0&id=398b0351&prod&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "398b0351",
  null
  
)

export default component.exports